import * as React from "react";
import "../../style/fonts.css";
import "./deleteUser.css";
import translate from "../../translations/i18n";
import CtaButton from "../ctaButton/ctaButton";
import {
  deleteAcc,
  deleteAccParam,
  resetDeleteVars,
  reAuthWithFacebook
} from "../../store/actions/deleteAction";
import { withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";

export interface Props {
  auth: any;
  deleteAcc(): void;
  deleteAccParam(): void;
  resetDeleteVars(): void;
  reAuthWithFacebook(): void;
  history: any;
  deleteUser: any;
  deleteParam: any;
  deleteUserCompleted: any;
  deleteParamCompleted: any;
  reauthenticateFaceComp: any;
}

class DeleteUserAcc extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);

    this.goBack = this.goBack.bind(this);
    this.deleteUser = this.deleteUser.bind(this);
    this.facebookRegister = this.facebookRegister.bind(this);
  }

  goBack() {
    this.props.history.goBack();
  }

  async deleteUser() {
    try {
      await this.props.deleteAccParam();
    } catch (e) {
      console.log(e)
    }

    try {
      await this.props.deleteAcc();
    } catch (e) {
      console.log(e)
    }
  }

  async facebookRegister() {
    try {
      await this.props.reAuthWithFacebook();
    } catch (e) {
      console.log(e)
    }
  }

  handleFacebookUsers() {
    let providerType;
    if (this.props.auth.providerData) {
      this.props.auth.providerData.forEach(element => {
        if (element.providerId === "password") {
          providerType = "email";
        } else if (element.providerId === "facebook.com") {
          providerType = "facebook";
        } else {
          providerType = null;
        }
      });
    }
    if (providerType === "email") {
      return (
        <div className="DELETE_BTN_CONT" onClick={this.deleteUser}>
          <CtaButton
            width={"155px"}
            text={translate("CTA_DELETE_ACCOUNT")}
            color={"blue"}
          />
        </div>
      );
    } else if (providerType === "facebook") {
      if (this.props.reauthenticateFaceComp === true) {
        return (
          <div className="DELETE_BTN_CONT" onClick={this.deleteUser}>
            <CtaButton
              width={"155px"}
              text={translate("CTA_DELETE_ACCOUNT")}
              color={"blue"}
            />
          </div>
        );
      } else {
        return (
          <div className="DELETE_BTN_CONT" onClick={this.facebookRegister}>
            <CtaButton width={"155px"} text={"LOGIN"} color={"blue"} />
          </div>
        );
      }
    } else return null;
  }

  componentDidMount() {
    this.props.resetDeleteVars();
  }

  render() {
    if (
      this.props.deleteParamCompleted === true &&
      this.props.deleteUserCompleted === true
    ) {
      this.props.resetDeleteVars();
      return <Redirect to="/appHome" push />;
    } else if (
      this.props.deleteParamCompleted === true &&
      this.props.deleteUserCompleted === false
    ) {
      return <Redirect to="/enterPass" push />;
    }
    return (
      <div className="DELETE_USER_CONT">
        <div className="DELETE_USER_TITLE">
          <div className="TITLE_2">{translate("CONFIRM_DELETE_TITLE")}</div>
        </div>
        <div className="DELETE_USER_TEXT">
          <div className="REG_TEXT">{translate("CONFIRM_DELETE_TEXT")}</div>
        </div>
        <div className="DELETE_BACK_BTN_CONT">
          {this.handleFacebookUsers()}
          <div className="BACK_BTN_CONT" onClick={this.goBack}>
            <CtaButton
              width={"155px"}
              text={translate("CTA_BACK_TO_LOGIN")}
              color={"white"}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    deleteUser: state.del.deleteUser,
    deleteParam: state.del.deleteParam,
    deleteUserCompleted: state.del.deleteUserCompleted,
    deleteParamCompleted: state.del.deleteParamCompleted,
    reauthenticateFaceComp: state.del.reauthenticateFaceComp,
    auth: state.firebase.auth
  };
};

const mapDispatchToProps = dispatch => {
  return {
    deleteAcc: () => dispatch(deleteAcc()),
    deleteAccParam: () => dispatch(deleteAccParam()),
    resetDeleteVars: () => dispatch(resetDeleteVars()),
    reAuthWithFacebook: () => dispatch(reAuthWithFacebook())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DeleteUserAcc));



// WEBPACK FOOTER //
// ./src/components/screens/deleteUser.tsx